module.exports = __webpack_public_path__ + "media/images/qr-code-share-610cb532e1d08ccab4f02f73a1001f88.png";